export default "__VITE_ASSET__BfZgE_md__"